import React from 'react';
import './App.css';
import {Outlet, RouterProvider} from "react-router-dom";
import router from './router/appRouter';

function App() {
    return (
        <div className="app-wrapper">
            <RouterProvider router={router}/>
            <Outlet/>
        </div>
    );
}

export default App;
